import { Locale as m, DEFAULT_LOCALE as u } from "../../constants/locale.js";
import { useLanguageContext as f } from "../../contexts/language/LanguageContext.js";
import { underscoreLocale as l, hyphenLocale as i } from "../../util/i18n/helper/locale.js";
import * as o from "ramda";
import { useEffect as L } from "react";
import { useTranslation as g } from "react-i18next";
const k = (n) => {
  const { locale: e } = n, { setLanguage: s } = f(), { i18n: t } = g();
  L(() => {
    const r = l(e || ""), a = o.find(o.equals(r), o.values(m)) || u;
    s(a);
    const c = i(a);
    t.changeLanguage(c);
  }, [e, t]);
};
export {
  k as default
};
//# sourceMappingURL=useLanguagePath.js.map
